/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Sender_EmailInputs */

const en_reference_field_sender_email = /** @type {(inputs: Reference_Field_Sender_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply-to address of its emails`)
};

/**
* | output |
* | --- |
* | "Reply-to address of its emails" |
*
* @param {Reference_Field_Sender_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_sender_email = /** @type {((inputs?: Reference_Field_Sender_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Sender_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_sender_email(inputs)
});